module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-05.7eb74a4c.jpg";